import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TareaCasoService } from 'src/app/services/tareacaso.service';
import { TareasService } from 'src/app/services/tareas.service';
import { CasoTareaService } from 'src/app/services/casos_tareas.service';
import { Regexs } from '@utils/regex';

@Component({
  selector: 'app-datos-candidato',
  templateUrl: './datos-candidato.component.html',
  styleUrls: ['./datos-candidato.component.scss'],
})
export class DatosCandidatoComponent implements OnInit {
  form: FormGroup;
  caso;
  idCaso;
  idTareas;
  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    console.log(task);
    this.form = this.fb.group({
      // titularEmisorCarta: [values ? values.titularEmisorCarta : '', [Validators.required]],
      // firma: [values ? values.firma : '', [Validators.required]],
      verificacion: [values ? values.verificacion : '', [Validators.required]],
      nombre: [values ? values.nombre : '', [Validators.required]],
      ci: [
        values ? values.ci : '',
        [Validators.required, Validators.pattern(Regexs.regexCiRif)],
      ],
      cargo: [values ? values.cargo : '', [Validators.required]],
      oferta_servicio: [
        values ? values.oferta_servicio : false,
        [Validators.required],
      ],
      referencias: [values ? values.referencias : false, [Validators.required]],
      soporte: [values ? values.soporte : false, [Validators.required]],
    });
  }
  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
